import { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
 
const TutorLoginPage = () => {
 
    const navigate = useNavigate();
   
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });
 
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
 
    const handleLogin = async (e) => {
        e.preventDefault();
        const res = await fetch("https://kalakakshaaha.com/kks/api/v1/login/tutor", {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData)
        });
 
        const data = await res.json();
       
        if (data.success) {
            alert("Tutor Login Successful");
            navigate("/team-single");
        } else {
            alert(data.message);
        }
    };
 
    return (
        <Fragment>
            <Header />
            <PageHeader title={'Tutor Login'} curPage={'Tutor Login'} />
 
            <div className="login-section padding-tb section-bg">
                <div className="container">
                    <div className="account-wrapper">
 
                        <h3 className="title">Tutor Login</h3>
 
                        <form className="account-form" onSubmit={handleLogin}>
                            <div className="form-group"><input type="email" name="email" placeholder="Email" onChange={handleChange}/></div>
                            <div className="form-group"><input type="password" name="password" placeholder="Password" onChange={handleChange}/></div>
 
                            <div className="form-group text-center">
                                <button className="lab-btn"><span>Login</span></button>
                            </div>
                        </form>
 
                        <div className="account-bottom">
                            New Tutor? <Link to="/tutor/signup">Register</Link>
                        </div>
 
                    </div>
                </div>
            </div>
 
            <Footer />
        </Fragment>
    );
};
 
export default TutorLoginPage;